<template>
  <div class="google-credential-button" :id="containerId"></div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';

import { GoogleSignInButtonText, useAuthStore } from '@tallo/auth';

// Google's SDK renders into a node it finds by id and hands back the signed credential; what that
// credential is exchanged for (an invite, here) is the parent's call
const props = withDefaults(defineProps<{ text: GoogleSignInButtonText; containerId?: string }>(), {
  containerId: 'tallo-google-credential-button',
});
const emit = defineEmits<{ credential: [googleJwt: string] }>();

const authStore = useAuthStore();

onMounted(() => {
  authStore.renderGoogleSignInButton({
    containerHtmlElementId: props.containerId,
    text: props.text,
    callback: (googleJwt) => emit('credential', googleJwt),
  });
});
</script>

<style scoped lang="scss">
.google-credential-button {
  width: 100%;
  height: 2.75rem;
}
</style>
